// src/components/brandCustomization/TicketCustomization/TicketStyleEditor.jsx
import React from 'react';
import { ColorPicker } from '../shared';

/**
 * TicketStyleEditor - Editor de estilos para la tarjeta de puntos
 */
const TicketStyleEditor = ({ 
  styles, 
  onChange 
}) => {
  return (
    <div className="mt-6 pt-6 border-t border-gray-200">
      <h4 className="text-sm font-semibold text-gray-900 mb-4 flex items-center">
        <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
        Personalización Visual de la Tarjeta
      </h4>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Colores de la Tarjeta */}
        <ColorPicker
          label="Color de Fondo de la Tarjeta"
          value={styles.cardBackgroundColor || '#FFFFFF'}
          onChange={(value) => onChange('cardBackgroundColor', value)}
          placeholder="#FFFFFF"
        />

        <ColorPicker
          label="Color de Fondo del Header"
          value={styles.headerBackgroundColor || '#3B82F6'}
          onChange={(value) => onChange('headerBackgroundColor', value)}
          placeholder="#3B82F6"
        />

        <ColorPicker
          label="Color de Texto del Header"
          value={styles.headerTextColor || '#FFFFFF'}
          onChange={(value) => onChange('headerTextColor', value)}
          placeholder="#FFFFFF"
        />

        {/* Colores de Texto */}
        <ColorPicker
          label="Color de Texto Principal"
          value={styles.textColor || '#111827'}
          onChange={(value) => onChange('textColor', value)}
          placeholder="#111827"
        />

        <ColorPicker
          label="Color de Texto Secundario"
          value={styles.secondaryTextColor || '#6B7280'}
          onChange={(value) => onChange('secondaryTextColor', value)}
          placeholder="#6B7280"
        />

        {/* Colores de Puntos */}
        <ColorPicker
          label="Color de Puntos"
          value={styles.pointsColor || '#3B82F6'}
          onChange={(value) => onChange('pointsColor', value)}
          placeholder="#3B82F6"
        />

        <ColorPicker
          label="Color de Label de Puntos"
          value={styles.pointsLabelColor || '#6B7280'}
          onChange={(value) => onChange('pointsLabelColor', value)}
          placeholder="#6B7280"
        />

        {/* Colores de QR */}
        <ColorPicker
          label="Color de Fondo del QR"
          value={styles.qrBackgroundColor || '#FFFFFF'}
          onChange={(value) => onChange('qrBackgroundColor', value)}
          placeholder="#FFFFFF"
        />

        <ColorPicker
          label="Color de Borde del QR"
          value={styles.qrBorderColor || '#E5E7EB'}
          onChange={(value) => onChange('qrBorderColor', value)}
          placeholder="#E5E7EB"
        />

        {/* Otros */}
        <ColorPicker
          label="Color de Divisores"
          value={styles.dividerColor || '#E5E7EB'}
          onChange={(value) => onChange('dividerColor', value)}
          placeholder="#E5E7EB"
        />

        <ColorPicker
          label="Color de Iconos"
          value={styles.iconColor || '#3B82F6'}
          onChange={(value) => onChange('iconColor', value)}
          placeholder="#3B82F6"
        />

        <ColorPicker
          label="Color de Fondo de Página"
          value={styles.pageBackgroundColor || '#F9FAFB'}
          onChange={(value) => onChange('pageBackgroundColor', value)}
          placeholder="#F9FAFB"
        />

        {/* Tipografía */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Familia de Fuente
          </label>
          <select
            value={styles.fontFamily || 'sans-serif'}
            onChange={(e) => onChange('fontFamily', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="sans-serif">Sans Serif</option>
            <option value="serif">Serif</option>
            <option value="monospace">Monospace</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tamaño de Fuente
          </label>
          <select
            value={styles.fontSize || '16px'}
            onChange={(e) => onChange('fontSize', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="14px">14px (Pequeño)</option>
            <option value="16px">16px (Normal)</option>
            <option value="18px">18px (Grande)</option>
            <option value="20px">20px (Muy Grande)</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Radio de Borde de Tarjeta
          </label>
          <select
            value={styles.cardBorderRadius || '24px'}
            onChange={(e) => onChange('cardBorderRadius', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="0px">Sin borde (0px)</option>
            <option value="8px">Pequeño (8px)</option>
            <option value="12px">Mediano (12px)</option>
            <option value="16px">Grande (16px)</option>
            <option value="24px">Muy Grande (24px)</option>
            <option value="32px">Redondeado (32px)</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default TicketStyleEditor;

